import {
  Button,
  Grid,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  Typography,
  useMediaQuery,
  Backdrop,
  CircularProgress
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import { Box } from "@mui/system";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CustomTextField from "../CustomComponents/CustomTextField";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import dayjs from "dayjs";
import { b64toBlob } from "../DownloadUtils";
import { SettlementFigureReportReducerAction } from "../Store/SettlementFigureReport/SettlementFigureReportReducer";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const SettlementFigureReport = (props) => {
  //Dispatch
  const dispatch = useDispatch();

  const filterValues = useSelector(
    (state) => state.settlementFigureReport.filterValues
  );

  const valueIsValid = useSelector(
    (state) => state.settlementFigureReport.valueIsValid
  );

  const touchHandler = useSelector(
    (state) => state.settlementFigureReport.touchHandler
  );

  const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationNumTouched && !valueIsValid.applicationNumIsValid;
  const expectedDateHasError =
    touchHandler.expectedDateTouched && !valueIsValid.expectedDateIsValid;
  const dropDownHasError =
    touchHandler.dropDownValueTouched && !valueIsValid.dropDownValueIsValid;
  const instructionHasError =
    touchHandler.instructionIsTouched && !valueIsValid.instructionIsValid;
  const reasonHasError =
    touchHandler.reasonIsTouched && !valueIsValid.reasonIsValid;

  const [expectedDateValidDateError, setExpectedDateDateValidDateError] =
    useState(false);

  const [disabledState, setDisabledState] = useState(
    !(filterValues.dropDownValue === "PRE - TAKEOVER")
  );
  //Select component drop down
  const [purposeOfSettlementFigureReport, setPurposeOfSettlementFigureReport] =
    useState([]);
  const [bankAndInstructions, setBankAndInstructions] = useState([]);
  const [reason, setReason] = useState([]);
  //Success Dialog Message Handler
  const [sucessDialogOpen, setSuccessDialogOpen] = useState(false);
  //Handle Sucess Dialog Message
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const userName = useSelector((state) => state.branch.userName);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  //shortcut
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const okRef = useRef(null);
  const cancelRef = useRef(null);
  const yesRef = useRef(null);
  useEffect(() => {
    getSettlementFigureReportValues();
    getPrePaymentReason();
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "settlementFigure",
      })
    );
  };
  const getSettlementFigureReportValues = async () => {
    try {
      const nachLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD017",
      });

      // const purposeOfSettlementFigureReportMap = nachLovValues.data[
      //   "Purpose of Settlement Figure Report"
      // ].map((type) => {
      //   return type.lovValues;
      // });
      // setPurposeOfSettlementFigureReport(purposeOfSettlementFigureReportMap);

      const bankAndInstructionsMap = nachLovValues.data[
        "Bank and Instructions"
      ].map((type) => {
        return type.lovValues;
      });
      setBankAndInstructions(bankAndInstructionsMap);
      const reasonMap = nachLovValues.data["Reason"].map((type) => {
        return type.lovValues;
      });
      setReason(reasonMap);
    } catch (e) {}
  };
  const getPrePaymentReason = async () => {
    try {
      const response = await axios.post(
        "/prepaymentCharges/getPrePaymentReason",
        { apiCode: "PRE_PAYMENT_REASONS_API", createdBy: userName }
      );
      if (response.data) {
        setPurposeOfSettlementFigureReport(response.data);
      } else {
        setPurposeOfSettlementFigureReport([]);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      setsavedDialogOpen(false);
    }
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    let refList = { okRef: okRef, cancelRef: cancelRef, yesRef: yesRef };
    if (event.ctrlKey) {
      if (charCode === "i") {
        dispatch(SettlementFigureReportReducerAction.updateExpectedDate(date));
        dispatch(
          SettlementFigureReportReducerAction.updateExpectedDateIsTouched(date)
        );
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        dispatch(SettlementFigureReportReducerAction.updateExpectedDate(date));
        dispatch(
          SettlementFigureReportReducerAction.updateExpectedDateIsTouched(date)
        );
      } else if (charCode === "f") {
        searchButtonRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "reportProcess",
          })
        );
      }
    }
  };

  const handlerSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);
  const [savedDialogOpen, setsavedDialogOpen] = useState(false);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateFromValue =
    fieldAccessMap.settlementFigureReport &&
    fieldAccessMap.settlementFigureBackCount
      ? 3 //from paramter
      : Number(0);
  let maxDateFromValue =
    fieldAccessMap.settlementFigureReport &&
    fieldAccessMap.settlementFigureFutureCount
      ? 4 //from paramter
      : Number(0);
  useEffect(() => {
    clearButtonHandler();
    dispatch(SettlementFigureReportReducerAction.updateBranchIsTouched(false));
    const branchArr = GetBranchDetails();
    dispatch(SettlementFigureReportReducerAction.updateBranchArray(branchArr));
    dispatch(
      SettlementFigureReportReducerAction.updateDropDownValueIsTouched(false)
    );
    dispatch(
      SettlementFigureReportReducerAction.updateApplicationNumberIsTouched(
        false
      )
    );
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const branchOnChangeHandler = async (value) => {
    dispatch(SettlementFigureReportReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      dispatch(
        SettlementFigureReportReducerAction.updateApplicationValue(null)
      );
      dispatch(SettlementFigureReportReducerAction.clearCustomerId());
      try {
        const branchCodeValue = getSelectedBranchCode(value.label);
        const response = await axios.post("/losCustomer/getLosAppNumByStatus", {
          branch: value.label,
          status: ["Disbursement Completed", "Disbursed", "Requested"],
          branchCode: branchCodeValue,
        });
        dispatch(
          SettlementFigureReportReducerAction.updateApplicationArray(
            response.data.sort()
          )
        );
      } catch (error) {
        throw Error(error);
      }
    } else {
      // on branch clear.
      dispatch(SettlementFigureReportReducerAction.updateApplicationArray([]));
      dispatch(
        SettlementFigureReportReducerAction.updateApplicationValue(null)
      );
      // reset  all the values on filter
      dispatch(SettlementFigureReportReducerAction.resetFilterValues());
    }
  };

  const applicationNumOnChangeHandler = async (value) => {
    dispatch(SettlementFigureReportReducerAction.updateApplicationValue(value));
    if (value && value !== "") {
      setLoading(true)
      setLoadingMsg("Application Details Loading.....")
      try {
        const response = await axios.post(
          "/losCustomer/getCustomerDataByAppNum",
          { applicationNum: value }
        );
        let record = response.data;
        let filterValues = {};
        filterValues.branch = record.branch;
        filterValues.applicationNum = record.applicationNum;
        filterValues.customerId = record.customerId;
        await axios
          .post("repayment/getApplicationDetails", {
            applicationNum: filterValues.applicationNum,
            requestedDate: null,
          })
          .then((response) => {
            let date = new Date(
              response.data[response.data.length - 1].dueDate
            );
            filterValues.expectedEndDate = new Date(
              dayjs(date).format("MM/DD/YYYY")
            );
            setLoading(false)
          });
        dispatch(
          SettlementFigureReportReducerAction.updateFilterValues(filterValues)
        );
      } catch (error) {
        setLoading(false)
        throw Error(error);
      }
    } else {
      dispatch(SettlementFigureReportReducerAction.clearCustomerId());
      dispatch(SettlementFigureReportReducerAction.resetExpectedDate());
    }
  };

  const validateData = () => {
    return valueIsValid.branchIsValid &&
      valueIsValid.applicationNumIsValid &&
      valueIsValid.dropDownValueIsValid &&
      valueIsValid.expectedDateIsValid
      ? true
      : false;
  };

  const validateReasonData = () => {
    return valueIsValid.reasonIsValid && valueIsValid.instructionIsValid
      ? true
      : false;
  };

  const goButtonHandler = () => {
    let isValidData = true;
    if (!disabledState) {
      isValidData = validateReasonData();
    }
    if (validateData() && isValidData) {
      setConfirmationDialogOpen(true);
    } else {
      dispatch(SettlementFigureReportReducerAction.updateBranchIsTouched(true));
      dispatch(
        SettlementFigureReportReducerAction.updateApplicationNumberIsTouched(
          true
        )
      );
      dispatch(
        SettlementFigureReportReducerAction.updateDropDownValueIsTouched(true)
      );
      if (!disabledState) {
        dispatch(
          SettlementFigureReportReducerAction.updateReasonIsTouched(true)
        );
        dispatch(
          SettlementFigureReportReducerAction.updateInstructionIsTouched(true)
        );
      }
    }
  };

  const paymentJvInprogressCheck = async () => {
      setConfirmationDialogOpen(false);
      setLoading(true)
      setLoadingMsg("Report downloading please wait.....")
      await axios
        .post("/checkInprogressPaymentAndJv", {
          applicationNum: filterValues.applicationNum,
        })
        .then((response) => {
          if (response.data) {
            downloadPdf();
          } else {
            setLoading(false)
            setConfirmationDialogOpen(false);
            setsavedDialogOpen(true);
          }
        }).catch(error=>{
          console.log("Error ",error)
          setLoading(false)
          throw Error(error)
        });
  };

  const downloadPdf = async () => {
    setConfirmationDialogOpen(false);
      //spinner made true in above method
      await axios
        .post("/generatePreCloseReport", {
          applicationNum: filterValues.applicationNum,
          preCloseDate: new Date(filterValues.expectedDate).toLocaleDateString(
            "fr-FR"
          ),
          settlementPurpose: filterValues.dropDownValue,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(
            b64toBlob(response.data, "application/pdf")
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `PreCloseReport-${filterValues.applicationNum}.pdf`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoading(false)
          setMessage("Report downloaded successfully.");
          setAlertType("success");
          openAlertHandler();
        }).catch(error=>{
          console.log("Error ",error)
          setLoading(false)
          throw Error(error)
        }); 
  };

  const clearButtonHandler = () => {
    dispatch(SettlementFigureReportReducerAction.resetFilterValues());
    dispatch(SettlementFigureReportReducerAction.resetAllTouchHandlers());
    setExpectedDateDateValidDateError(false);
    setDisabledState(true);
  };

  return (
    <React.Fragment>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{display: "flex",flexDirection: "column",gap: "8px",alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Settlement Figure Report"
          initialOpen={true}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={filterValues.branchArray}
                value={filterValues.branch}
                onChange={(event, newValue) => {
                  branchOnChangeHandler(newValue);
                  dispatch(
                    SettlementFigureReportReducerAction.updateBranchIsTouched(
                      true
                    )
                  );
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                label="Application Number"
                required={true}
                autoCompleteValues={filterValues.applicationArray}
                value={filterValues.applicationNum}
                onChange={(e, newValue) => {
                  applicationNumOnChangeHandler(newValue);
                  dispatch(
                    SettlementFigureReportReducerAction.updateApplicationNumberIsTouched(
                      true
                    )
                  );
                }}
              />
              {applicationHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Customer ID"
                variant="standard"
                placeholder="Customer ID"
                disabled={true}
                value={filterValues.customerId}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                label="Expected Date of Closure"
                variant="standard"
                disabled={false}
                required={true}
                minDate={currentDate}
                maxDate={filterValues.expectedEndDate}
                value={filterValues.expectedDate}
                onChange={(value) => {
                  dispatch(
                    SettlementFigureReportReducerAction.updateExpectedDate(
                      value
                    )
                  );
                  dispatch(
                    SettlementFigureReportReducerAction.updateExpectedDateIsTouched(
                      true
                    )
                  );
                  if (value !== null && value !== undefined && value !== "") {
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value) >= currentDate &&
                    new Date(value) <= filterValues.expectedEndDate
                      ? setExpectedDateDateValidDateError(false)
                      : setExpectedDateDateValidDateError(true);
                  } else {
                    setExpectedDateDateValidDateError(true);
                  }
                }}
              />
              {(expectedDateValidDateError || expectedDateHasError) && (
                <p className="error">Please Select Valid Date</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Report Type"
                variant="standard"
                placeholder="Enter Report Type"
                value="PDF"
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <>
                {/* <CustomDropDown
                  label="Purpose of Settlement Figure Report"
                  variant="standard"
                  defaultValue={"Pre-Death Claim"}
                  value={filterValues.dropDownValue}
                  dropDownValue={[
                    {
                      key: 1,
                      value: "Pre-Death Claim",
                      text: "Pre-Death Claim",
                    },
                    {
                      key: 2,
                      value: "Pre-Interest Subsidy received",
                      text: "Pre-Interest Subsidy received",
                    },
                    { key: 3, value: "Pre-Own Fund", text: "Pre-Own Fund" },
                    {
                      key: 4,
                      value: "Pre-Sale through Sartesi",
                      text: "Pre-Sale through Sartesi",
                    },
                    { key: 5, value: "PRE  TAKEOVER", text: "PRE  TAKEOVER" },
                  ]}
                  required={true}
                  onChange={(event) => {
                    dispatch(
                      SettlementFigureReportReducerAction.updateDropDownValue(
                        event.target.value
                      )
                    );
                    dispatch(
                      SettlementFigureReportReducerAction.updateDropDownValueIsTouched(
                        true
                      )
                    );
                    if (event.target.value !== "PRE  TAKEOVER") {
                      dispatch(
                        SettlementFigureReportReducerAction.resetReasonValues()
                      );
                    }
                  }}
                />
                {dropDownHasError && (
                  <p className="error">
                    Please Select Purpose of Settlement Figure Report
                  </p>
                )} */}
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  label="Purpose of Settlement Figure Report"
                  placeholder=" Please Select Purpose of Settlement Figure Report"
                  required={true}
                  autoCompleteValues={purposeOfSettlementFigureReport}
                  value={filterValues.dropDownValue}
                  onChange={(e, newValue) => {
                    setDisabledState(newValue !== "PRE - TAKEOVER");
                    dispatch(
                      SettlementFigureReportReducerAction.updateDropDownValue(
                        newValue
                      )
                    );
                    dispatch(
                      SettlementFigureReportReducerAction.updateDropDownValueIsTouched(
                        true
                      )
                    );
                    if (newValue !== "PRE - TAKEOVER") {
                      dispatch(
                        SettlementFigureReportReducerAction.resetReasonValues()
                      );
                    }
                  }}
                />
                {dropDownHasError && (
                  <p className="error">
                    Please Select Purpose of Settlement Figure Report
                  </p>
                )}
              </>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                type="text"
                label="Bank and Instructions"
                variant="standard"
                placeholder="Please Select Bank and Instructions"
                disabled={disabledState}
                required={!disabledState}
                autoCompleteValues={bankAndInstructions}
                value={filterValues.instruction}
                onChange={(e, v) => {
                  dispatch(
                    SettlementFigureReportReducerAction.updateInstruction(v)
                  );
                  dispatch(
                    SettlementFigureReportReducerAction.updateInstructionIsTouched(
                      true
                    )
                  );
                }}
              />
              {instructionHasError && (
                <p className="error">Please Select Bank and Instructions</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                type="text"
                label="Reason"
                variant="standard"
                placeholder="Please Select Reason"
                disabled={disabledState}
                required={!disabledState}
                autoCompleteValues={reason}
                value={filterValues.reason}
                onChange={(e, v) => {
                  dispatch(SettlementFigureReportReducerAction.updateReason(v));
                  dispatch(
                    SettlementFigureReportReducerAction.updateReasonIsTouched(
                      true
                    )
                  );
                }}
              />
              {reasonHasError && <p className="error">Please Select Reason</p>}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem" }}
                onClick={goButtonHandler}
                ref={searchButtonRef}
              >
                GO
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={clearButtonHandler}
                ref={clearRef}
              >
                Clear
              </Button>
            </Tooltip>
          </Box>
          <Dialog
            open={sucessDialogOpen}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Success"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {successDialogMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Ctrl+K" placement="top">
                <Button onClick={handlerSuccessDialogClose} ref={okRef}>
                  OK
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={alert}
            autoHideDuration={3000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </AccordianContainer>
      </Box>
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        open={confirmationDialogOpen}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {"Do you want to generate the report?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => setConfirmationDialogOpen(false)}
              sx={{ fontWeight: "bold" }}
              autoFocus
              ref={cancelRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              onClick={paymentJvInprogressCheck}
              sx={{ fontWeight: "bold" }}
              ref={yesRef}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        dialogOpen={savedDialogOpen}
        dialogTitle={
          <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
        }
        dialogContent={
          "Unable to download Report Since Payment or JV Inprogress"
        }
        hideCancelButton={false}
        okButtonName={"OK"}
        // disabled={saveOkButtonDisable}
        onOkClick={() => {
          setsavedDialogOpen(false);
        }}
      />
      <StlapFooter />
    </React.Fragment>
  );
};

export default SettlementFigureReport;
